<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 用户管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>登录信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.loginName" placeholder="登录名" class="handle-input mr10"></el-input>
                <el-date-picker
					type="datetime"
					placeholder="开始时间"
					v-model="query.createTimeStart"
					value-format="yyyy-MM-dd HH:mm:SS"
				></el-date-picker> &nbsp;
				<el-date-picker
					type="datetime"
					placeholder="结束时间"
					v-model="query.createTimeEnd"
					value-format="yyyy-MM-dd HH:mm:SS"
				></el-date-picker>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
            >
				<el-table-column prop="loginName" label="登录名"></el-table-column>
                <el-table-column prop="loginOsType" label="登录系统类型"></el-table-column>
				<el-table-column prop="ip" label="登录ip"></el-table-column>
				<el-table-column prop="validTime" label="有效期时间"></el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleOffline(scope.$index, scope.row)"
							v-if="controll['off-line']"
                        >强制下线</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchTokenData, offline } from '../../../api/index';
export default {
    name: 'token',
    data() {
        return {
            query: {
                pageIndex: 1,
                pageSize: 10
            },
            tableData: [],
            pageTotal: 0,
			controll:{}
        };
    },
    created() {
		this.controll = getControll("token");
        this.getData();
    },
    methods: {
        // 获取token数据
        getData() {
            fetchTokenData(this.query).then(res => {
                if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取登录数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleOffline(index, row) {
            // 二次确认删除
            this.$confirm('确定要强制下线用户' + row.loginName + '吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    offline(row.id).then(res => {
						if (res.code == 0) {
							this.$message.success('下线成功');
							this.getData();
						} else {
							this.$message.error(`下线失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
